import cn from 'classnames'
import { IFormMarketShare } from 'legacy/lut/classes/models/partner360/IFormMarketShare'
import { formatMoneyInteger } from 'legacy/lut/components/widgets/public/partner360/helpers/formatMoneyInteger'

import { Translation } from 'cng-common/features/translations/components/translation'
import { TPopupHorizontal } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'

import styles from '../../CategoryPlanning.module.scss'
import { actualsDirectColor, actualsIndirectColor } from '../../config'
import { getDivisor } from '../../helpers/getDivisor'
import { getFractionDigits } from '../../helpers/getFractionDigits'
import { getGtmPoints } from '../../helpers/getGtmPoints'

export const actualsWrapper = (
  actualsValue: number,
  actualsDirectValue: number,
  year: number,
  isRetail: boolean,
  marketShareData: IFormMarketShare[],
  isShowZero: boolean = false,
  fractionDigits: number = 0,
  rounding: string = '',
  tip: string = ''
) => {
  const divisor = getDivisor(rounding)
  const roundingFractionDigits = getFractionDigits(rounding)
  fractionDigits =
    !fractionDigits && roundingFractionDigits ? roundingFractionDigits : fractionDigits

  const formattedDirect =
    !isShowZero && actualsDirectValue === null
      ? '-'
      : formatMoneyInteger(actualsDirectValue, fractionDigits, divisor)

  let actualsIndirectValue: number | null = null
  if (actualsValue !== null) {
    actualsIndirectValue = actualsValue - actualsDirectValue
  }

  const formattedIndirect =
    !isShowZero && actualsIndirectValue === null
      ? '-'
      : formatMoneyInteger(actualsIndirectValue || 0, fractionDigits, divisor)

  const colorDirect = actualsDirectColor
  const colorIndirect = actualsIndirectColor

  if (!isRetail) {
    return (
      <Tooltip
        inline
        tipContent={() => (
          <div className={styles.productLineTip}>
            <span>{tip}</span>
          </div>
        )}
        horizontalStartPosition={TPopupHorizontal.Center}
        horizontalDirection={TPopupHorizontal.Center}
        disabled={!tip}
      >
        <div className={cn({ [styles.valueTip]: tip })} style={{ color: colorDirect }}>
          {formattedDirect}
        </div>
        <div className={cn({ [styles.valueTip]: tip })} style={{ color: colorIndirect }}>
          {formattedIndirect}
        </div>
      </Tooltip>
    )
  } else {
    const gtmOnline = getGtmPoints(marketShareData, actualsValue, year, 'Online')
    const gtmInstore = getGtmPoints(marketShareData, actualsValue, year, 'Instore')
    const gtmOnlineFormatted = formatMoneyInteger(gtmOnline, fractionDigits, divisor)
    const gtmInstoreFormatted = formatMoneyInteger(gtmInstore, fractionDigits, divisor)

    return (
      <Tooltip
        tipContent={() => (
          <span className={styles.tipContent}>
            <span className={styles.tipLine}>
              <Translation text="jbp-gtm-priorities-online-tip" span />
              {gtmOnlineFormatted}
            </span>
            <br />
            <span className={styles.tipLine}>
              <Translation text="jbp-gtm-priorities-instore-tip" span />
              {gtmInstoreFormatted}
            </span>
          </span>
        )}
      >
        <div className={cn({ [styles.valueTip]: tip })} style={{ color: colorDirect }}>
          {formattedDirect}
        </div>
        <div className={cn({ [styles.valueTip]: tip })} style={{ color: colorIndirect }}>
          {formattedIndirect}
        </div>
      </Tooltip>
    )
  }
}
